/**
 * Show instructions on running a launch agent.
 */

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import {toast} from '@wandb/weave/common/components/elements/Toast';
import {TargetBlank} from '@wandb/weave/common/util/links';
// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import copyToClipboard from 'copy-to-clipboard';
import React, {useCallback} from 'react';

import DocUrls from '../../../util/doc_urls';
import {QueueStatus} from '../Queues/queueUtil';
import {quoteIfMultiWord} from '../utils';
import * as S from './AddAgentDialog.styles';

type AddAgentDialogProps = {
  open: boolean;
  entityName: string;
  queueName: string;
  onClose: () => void;
  queueStatus: QueueStatus;
};

export const AddAgentDialog = ({
  open,
  entityName,
  queueName,
  onClose,
  queueStatus,
}: AddAgentDialogProps) => {
  // TODO: Use/create a generic code snippet component.
  //       The one at frontends/app/src/pages/QuickStart/QuickStartExperiment/CodeSnippet/CodeSnippet.tsx
  //       currently has an import cycle that prevents use.
  const codeSnippet = `wandb launch-agent -e ${entityName} -q ${quoteIfMultiWord(
    queueName
  )}`;

  const copy = useCallback(() => {
    copyToClipboard(codeSnippet);
    toast('Copied to clipboard');
  }, [codeSnippet]);

  const onCopyClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    copy();
  };

  return (
    <Dialog onClose={onClose} open={open}>
      <S.DialogTitle>
        <S.TitlePanel>
          <S.Title>Add an agent to ‘{queueName}’</S.Title>
          <Button icon="close" variant="ghost" onClick={onClose} />
        </S.TitlePanel>
      </S.DialogTitle>
      <DialogContent>
        Run this wandb command in your CLI to create an agent for this queue.
        {queueStatus === 'inactive' && (
          <>
            <br />
            This message will automatically close when a running agent is
            detected.
          </>
        )}
        <S.CodeSnippet>
          <S.Code>$ {codeSnippet}</S.Code>
          <Button
            icon="copy"
            variant="ghost"
            onClick={onCopyClick}
            tooltip="Copy to clipboard"
          />
        </S.CodeSnippet>
      </DialogContent>
      <S.DialogActions>
        <Button onClick={onClose} variant="primary" size="large">
          Close
        </Button>
        <TargetBlank href={DocUrls.launch}>
          <Button icon="documentation" variant="secondary" size="large">
            Documentation
          </Button>
        </TargetBlank>
      </S.DialogActions>
    </Dialog>
  );
};
